import { postRequest } from '@/core';
import { subOrders } from '@/requests';

export default async function getSubOrdersTotalsRequest(filter) {
	let url = subOrders.getTotalsPath();
	let response = await postRequest(url, {}, filter);
	return response;
}
